// SPDX-License-Identifier: AGPL-3.0-or-later

// parley: the product name comes from the instance (PARLEY_PRODUCT_NAME), which
// parley-web injects into index.html as window.__FLUXER_BOOTSTRAP__, like the
// client did before ec681e60. Upstream hard-codes "Fluxer" here.
function getBootstrapProductName(): string {
	if (typeof window === 'undefined') {
		return 'Parley';
	}
	const bootstrap = (
		window as {__FLUXER_BOOTSTRAP__?: {instance?: {app_public?: {branding?: {product_name?: unknown}}}}}
	).__FLUXER_BOOTSTRAP__;
	const productName = bootstrap?.instance?.app_public?.branding?.product_name;
	return typeof productName === 'string' && productName.trim() ? productName.trim() : 'Parley';
}

export const PRODUCT_NAME = getBootstrapProductName();
export const DEFAULT_PREMIUM_PRODUCT_NAME = 'Plutonium';
